import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, confirmSignIn, signOut } from 'aws-amplify/auth';

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail]           = useState('');
  const [password, setPassword]     = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep]             = useState('login');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);

  const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');
  try {
    try { await signOut(); } catch {}
    const { isSignedIn, nextStep } = await signIn({ username: email, password });

    if (isSignedIn) {
      onLogin();
      return;
    }

    switch (nextStep.signInStep) {
      case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':
        setStep('new_password');
        break;
      case 'DONE':
        onLogin();
        break;
      default:
        setError(`Unexpected step: ${nextStep.signInStep}`);
    }
  } catch (err) {
    console.error('Login error:', err);
    setError(err.message || 'Login failed');
  } finally {
    setLoading(false);
  }
};

const handleNewPassword = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');
  try {
    const { isSignedIn } = await confirmSignIn({
      challengeResponse: newPassword,
      options: { userAttributes: { "name": email.split('@')[0] } }
    });
    if (isSignedIn) onLogin();
  } catch (err) {
    setError(err.message || 'Password change failed');
  } finally {
    setLoading(false);
  }
};


  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#f0f4f8'
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '40px 36px',
        width: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        border: '1px solid #e2e8f0'
      }}>
        {/* Back link */}
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#94a3b8', fontSize: 12, padding: '0 0 20px', display: 'flex',
            alignItems: 'center', gap: 4,
          }}
        >
          ← Back to home
        </button>

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 12,
            background: 'linear-gradient(135deg, #0ea5e9, #0284c7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: 20, fontWeight: 800
          }}>P</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 18, color: '#0a1628' }}>Praveda</div>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>by Btrix Technologies</div>
          </div>
        </div>

        {step === 'login' && (
          <>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>Welcome back</div>
            <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 28 }}>Sign in to your account</div>

            {error && (
              <div style={{
                background: '#fee2e2', color: '#dc2626', padding: '10px 14px',
                borderRadius: 8, fontSize: 13, marginBottom: 16
              }}>{error}</div>
            )}

            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@hospital.com"
                  required
                  style={{
                    width: '100%', padding: '10px 12px', borderRadius: 8,
                    border: '1px solid #e2e8f0', fontSize: 13, outline: 'none',
                    color: '#1e293b', background: '#f8fafc', boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: 24 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  style={{
                    width: '100%', padding: '10px 12px', borderRadius: 8,
                    border: '1px solid #e2e8f0', fontSize: 13, outline: 'none',
                    color: '#1e293b', background: '#f8fafc', boxSizing: 'border-box'
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%', padding: '11px', borderRadius: 8,
                  background: loading ? '#94a3b8' : 'linear-gradient(135deg, #0ea5e9, #0284c7)',
                  color: '#fff', border: 'none', fontSize: 14, fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Signing in...' : 'Sign in'}
              </button>
            </form>
          </>
        )}

        {step === 'new_password' && (
          <>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>Set new password</div>
            <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 28 }}>
              You need to set a new password before continuing.
            </div>

            {error && (
              <div style={{
                background: '#fee2e2', color: '#dc2626', padding: '10px 14px',
                borderRadius: 8, fontSize: 13, marginBottom: 16
              }}>{error}</div>
            )}

            <form onSubmit={handleNewPassword}>
              <div style={{ marginBottom: 24 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>
                  New Password
                </label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="Min 8 characters"
                  required
                  style={{
                    width: '100%', padding: '10px 12px', borderRadius: 8,
                    border: '1px solid #e2e8f0', fontSize: 13, outline: 'none',
                    color: '#1e293b', background: '#f8fafc', boxSizing: 'border-box'
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%', padding: '11px', borderRadius: 8,
                  background: loading ? '#94a3b8' : 'linear-gradient(135deg, #0ea5e9, #0284c7)',
                  color: '#fff', border: 'none', fontSize: 14, fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Setting password...' : 'Set password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}